export default {
    Region: 'ap-northeast-1',
    UserPoolId: 'ap-northeast-1_zfRfnszOy',
    ClientId: '2p57m7rvftr4qct711bovbh77d',
    IdentityPoolId: 'ap-northeast-1:f821be31-edf9-4008-afee-73d21a6f5844'
}